import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationImabariPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationImabari,
);
